import { t } from '../../utils/i18n';
import { procedureDisplayName } from '../../utils/procedureDisplay';

export function loadProcedureInformation(procedure, category) {
    return `
        <div class="popup__background procedure__information" data-procedure-id="${procedure.id}"></div>
        <div class="procedureBody__content">
            <h4 class="procedureBody__title">${procedureDisplayName(procedure)}</h4>
            <p class="procedure-body__text">${procedure.description}</p>
            <div class="procedure__actions">
                <div class="procedure-body__close-btn" data-procedure-id="${procedure.id}">
                    <i class="ri-close-line"></i>
                </div>
                <div class="procedure-body__add-procedure-btn" data-procedure-id="${procedure.id}" data-category="${category}">${t('add_procedure')}</div>
            </div>
        </div>
    `;
}
